<!--@author Tommaso Lazzaretti-->
<div class="sidebar-layout">
  <div class="mb-2">
    <ebw-monorepo-sidebar-header [icon]="'water_drop'" [title]="'map.sidebar.psa.title'" [isSvg]="false" [isOutline]="true" [fill]="true">
      {{ 'map.sidebar.psa.info_section' | translate }}
    </ebw-monorepo-sidebar-header>

    <div class="d-flex align-items-center justify-content-end">
      <button mat-icon-button (click)="openFilesystem()" [matTooltip]="'map.sidebar.psa.documents' | translate">
        <mat-icon>inventory</mat-icon>
      </button>
    </div>
  </div>

  <mat-tab-group [selectedIndex]="formSelectedTab.value" (selectedIndexChange)="onTabChange($event)" animationDuration="0ms">
    <mat-tab [label]="tab.tab_name" *ngFor="let tab of visibleTabs">
      <div class="row align-items-center mt-2 w-100">
        <ng-container *ngIf="tab.tab_id === 'Elementi'">
          <div class="col">
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>{{ 'map.sidebar.psa.search' | translate }}</mat-label>
              <mat-select (selectionChange)="changeElementType($event)" [(ngModel)]="selectedType">
                <mat-option *ngFor="let option of typesList" [value]="option.tipologia">{{ option.tipologia }} - {{ option.type }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2">
            <button mat-mini-fab color="primary" (click)="onCreateNew()" [matTooltip]="'map.sidebar.psa.create' | translate">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>{{ 'map.sidebar.psa.search' | translate }}</mat-label>
              <input matInput [disabled]="!selectedType" [(ngModel)]="filterTerm" (keyup)="onInputChange()" />
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="tab.tab_id === 'Eventi'">
          <div class="col">
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>{{ 'map.sidebar.psa.filter_type' | translate }}</mat-label>
              <mat-select [(ngModel)]="selectedType" (selectionChange)="onInputChange()">
                <mat-option [value]="null">{{ 'map.sidebar.psa.all_types' | translate }}</mat-option>
                <mat-option *ngFor="let option of typesList" [value]="option.tipologia">{{ option.tipologia }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-2">
            <button mat-mini-fab color="primary" (click)="onCreateNew()" [matTooltip]="'map.sidebar.psa.create' | translate">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>{{ 'map.sidebar.psa.search' | translate }}</mat-label>
              <input matInput [(ngModel)]="filterTerm" (keyup)="onInputChange()" />
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="tab.tab_id !== 'Elementi' && tab.tab_id !== 'Eventi'">
          <div class="col">
            <mat-form-field appearance="outline" class="mt-2 w-100">
              <mat-label>{{ 'map.sidebar.psa.search' | translate }}</mat-label>
              <input matInput [(ngModel)]="filterTerm" (keyup)="onInputChange()" />
            </mat-form-field>
          </div>

          <div *ngIf="['eventi', 'azioni'].includes(tab.tab_name.toLowerCase())" class="col-2">
            <button mat-mini-fab color="primary" (click)="onCreateNew()" [matTooltip]="'map.sidebar.psa.create' | translate">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </ng-container>
      </div>

      <div class="parent-div mt-2">
        <mat-list *ngIf="listElements && listElements.length > 0">
          <mat-list-item *ngFor="let item of listElements; trackBy: trackByFn">
            <div class="d-flex justify-content-between align-items-center py-2">
              <div class="item-container" *ngIf="selectedTab === 0">
                <div matLine class="item item-title">{{ item.nome }}</div>
              </div>
              <div class="item-container" *ngIf="selectedTab === 1">
                <div matLine class="item item-title" [title]="item.search_term">{{ item.search_term }}</div>
                <div matLine class="item item-subtitle">{{ item.type }}</div>
              </div>

              <div class="item-container" *ngIf="selectedTab === 2">
                <div matLine class="item item-title" [title]="item.nome">{{ item.nome }}</div>
                <div matLine class="item item-subtitle">{{ tipologieLabel(item) }}</div>
              </div>

              <div class="item-container" *ngIf="selectedTab === 3">
                <div
                  matLine
                  class="item item-title cursor-info"
                  [matMenuTriggerFor]="tooltipMenu"
                  #menuTrigger="matMenuTrigger"
                  (click)="toggleTooltip(menuTrigger)"
                >
                  {{ item.nome }}
                </div>

                <div matLine class="item item-subtitle" [title]="item.descrizione">{{ item.descrizione }}</div>

                <mat-menu #tooltipMenu="matMenu">
                  <div class="tooltip-content p-3">
                    <strong class="pb-1">{{ item.nome }}</strong>
                    <p>Ulteriori informazioni su {{ item.descrizione }}</p>
                  </div>
                </mat-menu>
              </div>

              <button mat-icon-button [matMenuTriggerFor]="menu" class="ml-auto center-horizontally">
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu="matMenu" class="menu-panel" (click)="$event.stopPropagation()">
                <button mat-menu-item class="w-100" (click)="showDetail(item)" *ngIf="tab.actions.includes(Actions.DETAIL)">
                  <mat-icon class="me-1" color="primary">info</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.detail' | translate }}</span>
                </button>

                <button mat-menu-item class="w-100" (click)="centerOnMap(item)" *ngIf="tab.actions.includes(Actions.CENTER_MAP)">
                  <mat-icon class="me-1" color="primary">my_location</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.center' | translate }}</span>
                </button>

                <button mat-menu-item class="w-100" (click)="evidence(item)" *ngIf="tab.actions.includes(Actions.EVIDENCE)">
                  <mat-icon class="me-1" color="primary">brightness_high</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.evidence' | translate }}</span>
                </button>

                <button
                  mat-menu-item
                  class="w-100"
                  *ngIf="tab.actions.includes(Actions.DOWNLOAD_MATRICE_RISCHIO)"
                  [matMenuTriggerFor]="matrice_rischio"
                >
                  <mat-icon class="me-1" color="primary">apps_outage</mat-icon>
                  <span>{{ 'map.sidebar.psa.risk_matrix_all' | translate }}</span>
                </button>

                <!-- Sub menu matrice rischio -->
                <mat-menu #matrice_rischio="matMenu">
                  <button mat-menu-item (click)="openMatriceRischioTotale(item, false)">
                    {{ 'map.sidebar.psa.actions.matrice_rischio.view' | translate }}
                  </button>
                  <button mat-menu-item (click)="openMatriceRischioTotale(item, true)">
                    {{ 'map.sidebar.psa.actions.matrice_rischio.download_filesystem' | translate }}
                  </button>
                </mat-menu>

                <button mat-menu-item class="w-100" (click)="goToCheckList(item)" *ngIf="tab.actions.includes(Actions.CHECK_LIST) && hasChecklist(item)">
                  <mat-icon class="me-1" color="accent">list_alt</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.check_list' | translate }}</span>
                </button>

                <button mat-menu-item class="w-100" (click)="modifyItem(item)" *ngIf="tab.actions.includes(Actions.MODIFY)">
                  <mat-icon class="me-1" color="accent">edit</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.modify' | translate }}</span>
                </button>

                <button mat-menu-item class="w-100" (click)="removeItem(item)" *ngIf="tab.actions.includes(Actions.DELETE)">
                  <mat-icon class="me-1" color="warn">delete</mat-icon>
                  <span>{{ 'map.sidebar.psa.actions.delete' | translate }}</span>
                </button>
              </mat-menu>
            </div>
          </mat-list-item>
        </mat-list>

        <span class="warning-label" *ngIf="listElements && listElements.length === 0">
          <mat-icon class="me-2">warning_amber</mat-icon>
          {{ 'map.sidebar.psa.no_elements_found' | translate }}
        </span>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
